import React, { useEffect, useState } from 'react';
import Resizer from 'react-image-file-resizer';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useToast } from '../../components/controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';

const defaultImg = 'images/default.png';

export function SideUploader({
  SetImage,
  initImage,
  refreshInitImage,
  Width = 1400,
  Height = 1400,
}) {
  const [value, setValue] = useState(initImage || defaultImg);
  const toast = useToast()
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        Width,
        Height,
        'png',
        200,
        0,
        (uri) => resolve(uri),
        'file'
      );
    });

  useEffect(() => {
    setValue(initImage || defaultImg);
  }, [refreshInitImage, initImage]);

  const showPreviewH = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValue(x.target.result);
      };
      resizeFile(imageFile)
        .then((data) => {
          reader.readAsDataURL(data);
          SetImage(data);
        })
        .catch((error) => {
          toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        });
    } else {
      setValue(defaultImg);
      SetImage('');
    }
  };

  return (
    <div className="relative w-full">
      <Zoom>
        <img
          src={value}
          alt="Profile"
          className="w-32 transition duration-300"
        />
      </Zoom>

      <input
        type="file"
        accept="image/*"
        id="upload_side"
        hidden
        onChange={showPreviewH}
      />

      <label
        htmlFor="upload_side"
        className="absolute bottom-2 right-2 bg-white p-2 rounded-full shadow cursor-pointer hover:scale-110 transition"
      >
        <svg
          className="w-5 h-5 text-indigo-700"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
          />
        </svg>
      </label>
    </div>
  );
}

